/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c552c281 (Wed Jul  1 16:38:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CashAmount, CashAmountFromJSON, CashAmountToJSON } from './'

/**
 *
 * @export
 * @interface FetchLcdTotalOwedResponse
 */
export interface FetchLcdTotalOwedResponse {
  /**
   *
   * @type CashAmount
   * @memberof FetchLcdTotalOwedResponse
   */
  totalBalance: CashAmount
  /**
   *
   * @type CashAmount
   * @memberof FetchLcdTotalOwedResponse
   */
  totalDue: CashAmount
}

export function FetchLcdTotalOwedResponseFromJSON(
  json: any
): FetchLcdTotalOwedResponse {
  return FetchLcdTotalOwedResponseFromJSONTyped(json, false)
}

export function FetchLcdTotalOwedResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchLcdTotalOwedResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    totalBalance: CashAmountFromJSON(json['totalBalance']),
    totalDue: CashAmountFromJSON(json['totalDue']),
  }
}

export function FetchLcdTotalOwedResponseToJSON(
  value?: FetchLcdTotalOwedResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    totalBalance: CashAmountToJSON(value.totalBalance),
    totalDue: CashAmountToJSON(value.totalDue),
  }
}
